<template>
    <div>
        <div class="title">报名信息填写</div>
        <div class="content">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm"
                     label-width="400px"
                     :label-position="labelPosition"  class="demo-ruleForm">
                <el-form-item label="姓名:"  prop="username">
<!--                    <el-col :xs="24" :sm="8" :md="10" :lg="12" :xl="22" slot="label">-->
<!--                        姓名-->
<!--                    </el-col>-->
                    <el-col :xs="24" :sm="smSpan" :md="14" :lg="12" :xl="2" class="right">
                        <el-input v-model="ruleForm.username" ></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="身份证号：" prop="idcard">
                    <el-col :xs="24" :sm="smSpan" :md="14" :lg="12" :xl="2" class="right">
                        <el-input v-model="ruleForm.idcard"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="手机号码：" prop="phone">
                    <el-col :xs="24" :sm="smSpan" :md="14" :lg="12" :xl="2" class="right">
                        <el-input v-model="ruleForm.phone"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="验证码：" prop="code">
                    <el-col :xs="24" :sm="smSpan" :md="14" :lg="12" :xl="2" class="right">
                        <el-row>
                            <el-col :xs="24-span" :sm="24-codeSmSpan" :md="14" :lg="14" :xl="2">
                                <el-input v-model="ruleForm.code"></el-input>
                            </el-col>
                            <el-col :xs="span" :sm="codeSmSpan" :md="10" :lg="10" :xl="2" style="text-align: right">
                                <el-button class="codeBtn" v-if="show" @click="getCode">获取验证码</el-button>
                                <el-button class="codeBtn1" v-if="!show">{{ times }}s</el-button>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-form-item>
                <!--                <el-form-item label="职务：" prop="job">-->
                <!--                    <el-col :span="12" class="right">-->
                <!--                        <el-select v-model="ruleForm.job" placeholder="请选择职务" style="width: 100%">-->
                <!--                            <el-option-->
                <!--                                    v-for="(option, index) in jobOption" :key="index"-->
                <!--                                    :label="option.label" :value="option.label"></el-option>-->
                <!--                        </el-select>-->
                <!--                    </el-col>-->
                <!--                </el-form-item>-->
                <el-form-item label="报名项目：" prop="job">
                    <el-col :xs="24" :sm="smSpan" :md="14" :lg="12" :xl="2" class="right">
                        <el-select v-model="projectIndex"
                                   @change="handleProjectChange"
                                   placeholder="请选择报名项目" style="width: 100%">
                            <el-option
                                    v-for="(option, index) in projectOptions" :key="index"
                                    :label="option.title" :value="index"></el-option>
                        </el-select>
                    </el-col>
                </el-form-item>
                <el-form-item label="海事综合服务平台资历截图：" prop="file">
                    <el-col :xs="24" :sm="smSpan" :md="14" :lg="12" :xl="2" class="right">
                        <el-upload
                                class="uploadCom"
                                list-type="picture-card"
                                accept="image/jpeg,image/gif,image/png,image/jpg"
                                multiple
                                :limit="9"
                                :file-list="fileList"
                                :action=uploadUrl
                                :show-file-list="true"
                                :headers="headers"
                                :on-exceed="handleLimit"
                                :on-success="handleAvatarSuccess">
                            <i slot="default" class="el-icon-plus"></i>
                            <div slot="file" slot-scope="{file}">
                                <!--                                {{file}}-->
                                <!--                                <div v-for="(img,index) in uploadImgs" :key="index">-->
                                <!--                                    <img  :src="img" class="el-upload-list__item-thumbnail">-->
                                <!--                                </div>-->
                                <img :src="file.url" class="el-upload-list__item-thumbnail">
                                <span class="el-upload-list__item-actions">
                                <span class="el-upload-list__item-preview"
                                      @click="handlePictureCardPreview(file)">
                                        <i class="el-icon-zoom-in"></i>
                                </span>
                                <span v-if="!disabled"
                                      class="el-upload-list__item-delete"
                                      @click="handleRemove(file)">
                                    <i class="el-icon-delete"></i>
                                </span>
                                </span>
                            </div>

                        </el-upload>
                    </el-col>
                </el-form-item>
                <el-form-item label="报名期数：" prop="job">
                    <el-col :xs="24" :sm="18" :md="18" :lg="18" :xl="2" class="right">
                        <el-row>
                            <el-col :xs="24" :sm="18" :md="18" :lg="18" :xl="2" style="text-align: left">
                                <el-radio-group v-model="enrollIndex" @change="handleEnrollChange">
                                    <el-radio
                                            v-for="(item, index) in enrollOptions" :key="index"
                                            :label="index"
                                            :disabled="item.title.substring(5,8) == '9月份' ? true : false">

                                        {{ item.title }}
                                    </el-radio>
                                </el-radio-group>
                            </el-col>
                            <el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="2" style="text-align: right">
                                <div class="retain">剩余名额：
                                    <div style="color: rgba(227, 60, 100, 1)" v-if="has_quota >= 0">{{ has_quota }}</div>
                                    <div style="color: rgba(227, 60, 100, 1)" v-else>0</div>
                                    人
                                </div>
                            </el-col>
                        </el-row>


                    </el-col>

                </el-form-item>
                <el-form-item label="推荐人(公司)：" prop="recommend_name">
                    <el-col :xs="24" :sm="smSpan" :md="14" :lg="12" :xl="2" class="right">
                        <el-input v-model="ruleForm.recommend_name"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="推荐人(公司)联系方式：" prop="recommend_phone">
                    <el-col :xs="24" :sm="smSpan" :md="14" :lg="12" :xl="2" class="right">
                        <el-input v-model="ruleForm.recommend_phone"></el-input>
                    </el-col>
                </el-form-item>
                <div class="check">
                    <el-checkbox v-model="checked"
                                 style="margin-right: 10px;transform: translate(0.6,0.6)"></el-checkbox>
                    本人已阅读报名须知，无异议。
                </div>
                <el-form-item class="btn-group">
                    <div>
                        <el-button @click="goLastPage" class="cancel-btn">上一步</el-button>
                        <el-button type="primary" @click="submitForm('ruleForm')" class="submit-btn">确认</el-button>

                    </div>
                </el-form-item>
            </el-form>
        </div>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
        <el-dialog
                :visible.sync="showTip"
                :width="myWidth"
                :show-close="false"
                :close-on-click-modal="false"
                center>
            <div class="dialogInfo">报名信息提交成功，需经审核，审核结果后期会以短信的形式发送到联系人手机上！</div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="hideShowTip" class="close-btn">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {urlConfig} from '@/common/urlConfig'
    import IdentityCodeValid from '@/utils/checkIdent'

    export default {
        name: "enter",
        data() {
            var validateIdCard = (rule, value, callback) => {
                console.log('value', value);
                    if (value === '') {
                        callback(new Error('请输入身份证号'));
                    } else if(!IdentityCodeValid(value)) {
                        callback(new Error('请输入正确的身份证号'));
                    } else {
                        if (this.ruleForm.idcard !== '') {
                            this.$refs.ruleForm.validateField('idCard');
                        }
                        callback();
                    }
                };
            return {
                ruleForm: {
                    username: '', // 姓名
                    idcard: '', // 身份证号码
                    phone: '', // 电话号码
                    code: '', // 验证码
                    job: '水手', // 职务
                    recommend_name: '', // 推荐人姓名
                    recommend_phone: '', // 推荐人手机号
                    file: '', // 图片
                    region: '',
                    date1: '',
                    date2: '',
                    delivery: false,
                    type: [],
                    desc: '',
                },
                rules: {
                    username: [
                        {required: true, message: '请输入姓名', trigger: 'blur'},
                        {max: 5, message: '长度小于 5 个字符', trigger: 'blur'}
                    ],
                    idcard: [
                        {required: true, validator:validateIdCard, trigger: 'blur'}
                    ],
                    phone: [
                        {required: true, message: '请输入联系电话', trigger: 'blur'}
                    ],
                    code: [
                        {required: true, message: '请输入验证码', trigger: 'blur'}
                    ],
                    region: [
                        {required: true, message: '请选择活动区域', trigger: 'change'}
                    ],
                    job: [
                        {required: true, message: '请选择职务', trigger: 'change'}
                    ],
                    file: [
                        {required: true, message: '请上传图片', trigger: 'change'}
                    ],
                },
                dialogImageUrl: '',
                dialogVisible: false,
                disabled: false,
                checked: true,
                projectOptions: [{
                    title: '',
                    enroll_class: [
                        {
                            title: '',
                            has_quota: 0
                        }
                    ]
                }], // 项目列表
                projectIndex: 0, // 列表index
                enrollOptions: [{
                    title: '',
                    has_quota: 0
                }], // 期数列表
                enrollIndex: 0, //期数index
                has_quota: 0, //名额
                jobOption: [
                    {
                        label: '水手'
                    },
                    {
                        label: '机工'
                    }
                ],
                value: '',
                access_token: '',
                headers: {
                    "Authorization": "",
                },
                uploadUrl: urlConfig + 'uploadImg',
                uploadImgs: [], // 图片
                fileList: [], // 上传的文件列表
                times: 60,
                timer: null,
                show: true,
                record_id: null, // 记录id
                showTip: false, //显示确认弹窗
                span: 15,
                smSpan: 16,
                codeSmSpan: 10,
                labelPosition: 'right',
                myWidth: '40%'
            };
        },
        created() {
            let timer = localStorage.getItem('timer')
            if(timer > 0) {
                console.log('timer', timer);
                this.getCountdown(timer);
            }
            this.getProjectList();

        },
        mounted() {
            let that = this;
            that.resizeSpan();
            window.onresize = function() {
                that.resizeSpan();
            }

        },

        methods: {
            // 重新设置span大小
            resizeSpan() {
                let w = document.documentElement.offsetWidth || document.body.offsetWidth;
                if(w>768) {
                    this.span = 15;
                    this.labelPosition = 'right'
                    this.smSpan = 16;
                    this.codeSmSpan = 10;
                    this.myWidth = '40%'
                }
                if(w <= 768) {
                    this.span = 6;
                    this.labelPosition = 'left'
                    this.smSpan = 24;
                    this.codeSmSpan = 6;
                    this.myWidth = '80%'
                }
                if(w < 600) {
                    this.span = 9;
                }
                if(w < 500) {
                    this.span = 11;
                }
                if(w < 400) {
                    this.span = 13;
                }
            },
            // 获取项目列表
            getProjectList() {
                this.$get('apply', {}).then((res) => {
                    console.log('res', res);
                    this.projectOptions = res.data.data.projects;
                    this.access_token = 'Bearer' + ' ' + res.data.data.access_token;
                    this.record_id = res.data.data.record.id;
                    this.headers.Authorization = this.access_token;
                    this.enrollOptions = this.projectOptions[0].enrollclass;
                    if (this.enrollOptions[0].title.substring(5, 8) == '9月份') {
                        this.enrollIndex = 1;
                    }
                    this.has_quota = this.enrollOptions[this.enrollIndex].has_quota;
                })
            },
            // 项目改变
            handleProjectChange(e) {
                console.log('e', e);
                this.enrollOptions = this.projectOptions[e].enrollclass;
                this.enrollIndex = 0;
                if (this.enrollOptions[0].title.substring(5, 8) == '9月份') {
                    this.enrollIndex = 1;
                }
                this.has_quota = this.enrollOptions[this.enrollIndex].has_quota;
            },
            // 期数改变
            handleEnrollChange(e) {
                // console.log('e', e);
                this.has_quota = this.enrollOptions[e].has_quota;
            },
            // 超过图片限制
            handleLimit(file) {
                // console.log('file', file);
                if(this.fileList.length + file.length > 9) {
                    this.$message.error('最多可以上传9张图片')
                }
            },
            // 上传图片成功
            handleAvatarSuccess(res, file, fileList) {
                // console.log('res', res, file, fileList);
                this.uploadImgs.push(res.data);
                this.fileList = fileList;
                this.ruleForm.file = this.uploadImgs.join(',');
                // this.ruleForm.file = res.data;
            },
            // 上传图片之前
            beforeAvatarUpload(file) {
                // console.log('file', file);
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 2MB!');
                }
                return isLt2M;
            },
            // 删除图片
            handleRemove(file) {
                console.log(file);
                console.log('fileList', this.fileList);
                this.fileList.map((i, n) => {
                    if (i.response.data == file.response.data) {
                        this.fileList.splice(n, 1);
                        this.uploadImgs.splice(n, 1);
                    }
                })
                console.log('this.uploadImgs', this.uploadImgs);
                // this.ruleForm.file = '';
            },
            // 预览图片
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            // 获取倒计时
            getCountdown(time) {
                this.show = false
                this.times = time;
                this.timer = setInterval(() => {
                    this.times--
                    localStorage.setItem('timer', this.times);
                    if (this.times === 0) {
                        this.show = true
                        clearInterval(this.timer)
                    }
                }, 1000)
            },
            // 获取验证码
            getCode() {

                if (!this.ruleForm.phone.trim()) {
                    this.$message.error('请输入手机号码');
                    return;
                }
                if (!this.formatTel(this.ruleForm.phone)) {
                    this.$message.error('请输入正确的手机号')
                    return false;
                }
                if (!this.ruleForm.idcard.trim()) {
                    this.$message.error('请输入身份证号');
                    return;
                }
                if (!IdentityCodeValid(this.ruleForm.idcard)) {
                    this.$message.error('请输入正确的身份证号')
                    return false;
                }

                this.$request('get', 'getCode', {
                    phone: this.ruleForm.phone,
                    idcard: this.ruleForm.idcard
                }, {
                    Authorization: this.access_token
                }).then((res) => {
                    console.log('res', res);
                    if (res.data == 0) {
                        this.getCountdown(60);
                        this.$message.success('发送成功');
                    } else {
                        this.$message.error(res.message);
                    }
                })


            },
            // 隐藏提示信息
            hideShowTip() {
                this.showTip = false;
                this.$router.push('/success');
            },
            handleDownload(file) {
                console.log(file);
            },
            // 手机号码验证
            formatTel(tel) {
                return /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(tel);
            },
            // 手机号和座机号验证
            formatPhone(val) {
                return /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/.test(val)
            },
            // 提交
            submitForm(formName) {
                if (!this.checked) {
                    this.$message.error('请勾选免责声明');
                    return;
                }
                this.ruleForm.file = this.uploadImgs.join(',');
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if(!/^([\u4e00-\u9fa5]+)$/.test(this.ruleForm.username)) {
                            this.$message.error('请输入正确的姓名')
                            return false;
                        }
                        if (!IdentityCodeValid(this.ruleForm.idcard)) {
                            this.$message.error('请输入正确的身份证号')
                            return false;
                        }
                        if (!this.formatTel(this.ruleForm.phone)
                        ) {
                            this.$message.error('请输入正确的联系电话')
                            return false;
                        }
                        if(this.ruleForm.recommend_phone) {
                            if (!this.formatPhone(this.ruleForm.recommend_phone)
                            ) {
                                this.$message.error('请输入正确的推荐人联系方式')
                                return false;
                            }
                        }
                        if(!this.projectOptions[this.projectIndex].id) {
                            this.$message.error('请选择项目')
                            return false;
                        }
                        if(!this.enrollOptions[this.enrollIndex].id) {
                            this.$message.error('请选择期数')
                            return false;
                        }

                        let submitData = {
                            username: this.ruleForm.username,
                            idcard: this.ruleForm.idcard,
                            phone: this.ruleForm.phone,
                            job: this.projectOptions[this.projectIndex].title == '水手晋升三副' ? '水手' : '机工',
                            files: this.ruleForm.file,
                            code: this.ruleForm.code,
                            recommend_name: this.ruleForm.recommend_name,
                            recommend_phone: this.ruleForm.recommend_phone,
                            project_id: this.projectOptions[this.projectIndex].id,
                            class_id: this.enrollOptions[this.enrollIndex].id,
                            record_id: this.record_id
                        }
                        this.$request('post', 'submit', submitData, {
                            Authorization: this.access_token
                        }).then((res) => {
                            console.log('res', res);
                            if(res.data == 0) {
                                this.showTip = true;
                            } else {
                                this.$message.error(res.message);
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            goLastPage() {
                this.$router.go(-1);
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            }
        }
    }
</script>

<style scoped>
    @media only screen and (max-width: 1130px) {
        .content {
            width: 100% !important;
        }
    }
    @media only screen and (max-width: 1024px) {
        /deep/ .el-form-item__label {
            width: 33% !important;
        }
        /deep/ .el-form-item__content {
            margin-left:33% !important;
        }
        .content {
            width: 100% !important;
        }
    }
    @media only screen and (max-width: 860px) {
        /deep/ .el-form-item__label {
            width: 30% !important;
        }
        /deep/ .el-form-item__content {
            margin-left:30% !important;
        }
        .content {
            width: 100% !important;
        }
    }
    @media only screen and (max-width: 768px) {
        /deep/ .el-form-item__label {
            width: 100% !important;
        }
        /deep/ .el-form-item__content {
            margin-left: 0 !important;
        }
        .content {
            width: 100% !important;
        }
    }
    @media only screen and (max-width: 480px) {
        /deep/ .el-radio {
            /*margin-top: 10px;*/
        }
    }
    .title {
        color: rgba(51, 101, 225, 1);
        font-size: 24px;
        font-weight: 600;
    }

    .content {
        width: 1130px;
        border-radius: 20px;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.06);
        margin: 50px auto;
        padding: 20px 30px;
        box-sizing: border-box;
    }

    .content .right {
        margin-left: 8px;
        text-align: left;
    }

    .content .right .codeBtn {
        background: rgba(51, 101, 225, 1);
        color: #ffffff;
        width: 112px;
    }
    .content .right .codeBtn1 {
        background: #BBC1D0;
        color: #ffffff;
        width: 112px;
        border: 1px solid #BBC1D0;
    }

    .content .right .retain {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
    }

    .check {
        width: 100%;
        margin-bottom: 34px;
    }

    .submit-btn {
        background: #3365e1;
        color: #ffffff;
    }

    .cancel-btn {
        border: 1px solid #3365e1;
        color: #3365e1;
    }

    .uploadCom {
        /*width: 148px;*/
        /*height: 148px;*/
        /*overflow: hidden;*/
    }

    .dialogInfo {
        font-size: 16px;
        font-weight: 600;
        color: #000;
        line-height: 2;
        text-align: center;
    }

    .close-btn {
        background: #3365e1;
    }
    /deep/ .el-form-item {
        width: 100%;
    }

    /* 选中后的字体颜色 */
    /deep/ .el-radio__input.is-checked + .el-radio__label {
        color: #3365e1 !important;
    }

    /* 选中后小圆点的颜色 */
    /deep/ .el-radio__input.is-checked .el-radio__inner {
        background: #3365e1 !important;
        border-color: #3365e1 !important;
    }

    /deep/ .btn-group .el-form-item__content {
        margin-left: 0 !important;
    }

    /deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
    /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        border-color: #3365e1 !important;
        background-color: #3365e1 !important;
    }

    /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #3365e1 !important;
    }

    /deep/ .el-checkbox__inner:hover {
        border-color: #3365e1 !important;
    }

    /deep/ .el-checkbox__input.is-focus .el-checkbox__inner {
        border-color: #3365e1 !important;
    }
    /deep/ .el-radio__input.is-disabled+span.el-radio__label {
        color: #C0C4CC;
        cursor: default;
    }

</style>
